module.exports = __webpack_public_path__ + "static/img/station1.8488f488.png";